module.exports = __webpack_public_path__ + "img/add_annoucment_hover.0bde2206.svg";